import { render, staticRenderFns } from "./RsaConfigurazioneStrutturaProvenienzaListComponent.vue?vue&type=template&id=64b671f9"
import script from "./RsaConfigurazioneStrutturaProvenienzaListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneStrutturaProvenienzaListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports